import React, { useEffect } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import NotFound from './pages/NotFound'
import { getEnv } from './utils/environment'
import BaseContextWrapper from './components/common/BaseContext'
import { LanguageProvider } from './contexts/LanguageContext'
import Login from './pages/Login'
import ProtectedRoute from './components/common/ProtectedRoute'
import SettingsUser from './pages/settings/SettingsUser'
import Currency from './pages/settings/Income'
import Expenses from './pages/expenses/Expenses'
import Home from './pages/Home'
import Earnings from './pages/earnings/earnings'
import Category from './pages/settings/category/category'
import Calculator from './pages/calculator/Calculator'
import TechCategory from './pages/settings/tech-category/TechCategory'
import Tech from './pages/tech/Tech'
import Salary from './pages/salary/Salary'
import Users from './pages/settings/users/Users'
import Employee from './pages/employee/Employee'
import TechOwn from './pages/own/TechOwn'
import SecretCode from './pages/settings/secret-code/SecretCode'
import Rent from './pages/rent/Rent'
import RentDetail from './pages/rent/RentDetail'
import UtilityBills from './pages/utility-bills/UtilityBills'
import UtilityBillsCreate from './pages/utility-bills/UtilityBillsCreate'
import UtilityBillsUpdate from './pages/utility-bills/UtilityBillsUpdate'
import Building from './pages/building/Building'
import BuildingDetail from './pages/building/BuildingDetail'
import Contract from './pages/building/Contract'
import Payment from './pages/building/Payment'
import Customer from './pages/building/Customer'
import Apartment from './pages/building/Apartment'
import Entrance from './pages/building/Entrance'
import BuildingCategory from './pages/settings/building-category/BuildingCategory'
import EmployeeSalary from './pages/employee/EmployeeSalary'
import Price from './pages/price/Price'
import TotalExpense from './pages/total-expense/TotalExpense'
import TotalExpenseCategory from './pages/settings/total-expense-category/TotalExpenseCategory'

export default function App() {
    useEffect(() => {
        if (getEnv() === 'production') return
        document.title = `${getEnv().toUpperCase()} ${document.title}`
    }, [])

    return (
        <LanguageProvider>
            <BrowserRouter>
                <BaseContextWrapper>
                    <Switch>
                        <Route path="/" component={Login} exact />
                        <ProtectedRoute path="/statistics" component={Home} exact />
                        <ProtectedRoute path="/rent" component={Rent} exact />
                        <ProtectedRoute path="/rent/:marketId" component={RentDetail} exact />
                        <ProtectedRoute path="/rent/:marketId/utility-bills" component={UtilityBills} exact />
                        <ProtectedRoute path="/rent/:marketId/utility-bills/create" component={UtilityBillsCreate} exact />
                        <ProtectedRoute path="/rent/:marketId/utility-bills/update/:billsId" component={UtilityBillsUpdate} exact />
                        <ProtectedRoute path="/building" component={Building} exact />
                        <ProtectedRoute path="/building/:buildId" component={BuildingDetail} exact />
                        <ProtectedRoute path="/building/:buildId/employee" component={Employee} exact />
                        <ProtectedRoute path="/building/:buildId/salary" component={EmployeeSalary} exact />
                        <ProtectedRoute path="/building/:buildId/contract" component={Contract} exact />
                        <ProtectedRoute path="/building/:buildId/payment" component={Payment} exact />
                        <ProtectedRoute path="/building/:buildId/customer" component={Customer} exact />
                        <ProtectedRoute path="/building/:buildId/apartment" component={Apartment} exact />
                        <ProtectedRoute path="/building/:buildId/entrance" component={Entrance} exact />
                        <ProtectedRoute path="/expense-report" component={Expenses} exact />
                        <ProtectedRoute path="/tech" component={Tech} exact />
                        <ProtectedRoute path="/total-expense" component={TotalExpense} exact />
                        <ProtectedRoute path="/own-tech" component={TechOwn} exact />
                        <ProtectedRoute path="/employee/salary/:employeeId" component={Salary} exact />
                        <ProtectedRoute path="/employee" component={Employee} exact />
                        <ProtectedRoute path="/earnings" component={Earnings} exact />
                        <ProtectedRoute path="/calculator" component={Calculator} exact />
                        <ProtectedRoute path="/settings/user" component={SettingsUser} exact />
                        <ProtectedRoute path="/settings/secret-code" component={SecretCode} exact />
                        <ProtectedRoute path="/settings/income" component={Currency} exact />
                        <ProtectedRoute path="/settings/rent-category" component={Category} exact />
                        <ProtectedRoute path="/settings/building-category" component={BuildingCategory} exact />
                        <ProtectedRoute path="/settings/tech-category" component={TechCategory} exact />
                        <ProtectedRoute path="/settings/total-expense-category" component={TotalExpenseCategory} exact />
                        <ProtectedRoute path="/settings/price" component={Price} exact />
                        <ProtectedRoute path="/users" component={Users} exact />
                        <Route path="" component={NotFound} exact />
                    </Switch>
                </BaseContextWrapper>
            </BrowserRouter>
        </LanguageProvider>
    )
}
